//@ts-strict-ignore
import React from 'react';
import styled from 'styled-components';
import numeral from 'numeral';
import AnimatedNumber from 'react-animated-number';
import PropTypes from 'prop-types';

import { ResponsiveBar } from '@nivo/bar';

const HeaderContainer = styled.div`
  position: absolute;
  bottom: 32%;
  left: 0;
  width: 100%;
  text-align: center;
`;

const HeaderValue = styled.div`
  font-size: 24px;
  font-weight: 400;
  color: #797775;
  line-height: 26px;
`;

const HeaderText = styled.div`
  font-size: 14px;
  font-weight: 300;
  text-transform: uppercase;
  color: #8d9096;
  margin-bottom: 20px;
`;

const colourScheme: Array<`#${string}`> = ['#4caf50', '#ffa000', '#f44336'];

type INivoProgressProps = {
  target: number;
  value: number;
  graphColours?: Array<`#${string}`>;
  color?: `#${string}`;
  foreColour?: `#${string}`;
  fontSize?: number;
  valueMask?: string | null;
  subTitle?: string | null;
};

const NivoProgress = ({
  target,
  value,
  graphColours,
  color,
  foreColour,
  fontSize,
  valueMask,
  subTitle,
}: INivoProgressProps) => {
  let percent = Math.abs(Math.round((value / target) * 100.0) / 100.0);
  if (percent >= 1) percent = 0.99; //Prevent going over 100%, progress bar does not act sensibly in this scenario.

  const scheme: Array<`#${string}`> = graphColours || colourScheme;

  const targetRemaining = target - value;

  const data = [
    {
      id: 'singleEntry',
      sales: value,
      targetRemaining: targetRemaining >= 0 ? targetRemaining : 0,
    },
  ];

  const firstColour = scheme[2 - Math.floor(percent * 3)];

  return (
    <>
      <HeaderContainer>
        <HeaderValue style={{ color: color }}>
          <AnimatedNumber
            value={value}
            style={{
              transition: '0.8s ease-out',
              fontSize: fontSize,
              transitionProperty: 'color, opacity',
              color: foreColour,
            }}
            duration={1000}
            formatValue={(fValue) => numeral(fValue).format(valueMask)}
          />
        </HeaderValue>
        <HeaderText style={{ color: color }}>{subTitle}</HeaderText>
      </HeaderContainer>
      <div style={{ position: 'absolute', width: '100%', bottom: 0, height: 75, paddingRight: '20px' }}>
        <div style={{ height: 75, width: '100%', position: 'relative' }}>
          <ResponsiveBar
            data={data}
            keys={['sales', 'targetRemaining']}
            margin={{ top: 20 }}
            padding={0.3}
            layout="horizontal"
            colors={[firstColour, '#EEEEEE']}
            borderColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
            axisTop={null}
            axisRight={null}
            axisBottom={null}
            axisLeft={null}
            enableLabel={false}
            animate={true}
            motionConfig={{ damping: 15, friction: 90 }}
            isInteractive={false}
          />
        </div>
      </div>
    </>
  );
};

NivoProgress.propTypes = {
  value: PropTypes.number,
};
NivoProgress.defaultProps = {
  value: 0,
  valueMask: '0,00.00',
};

export default NivoProgress;
